
define('jst!presence/presence_bar/_viewers',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<span class="avatars"></span>\n\n<% if (!compact) { %>\n  <span class="viewers <%= count > 0 ? \'enabled\' : \'\' %>">\n    <span class="slot-count text-bold"></span>\n    <%=t(\'Viewing #presencebar\') %>\n  </span>\n<% } %>\n');
 });

